import React, { useEffect, useState } from 'react';
import { isChipActive, resetInfoCard } from '../../../constants/promotionKeys';
import styles from './Chip.module.scss';
import sparkleGif from '../../../assets/images/sparkle.gif';

type Props = {
  id: string;
  label: string;
  icon?: React.ReactNode;
  onClick?: () => void;
  className?: string;
  cardId?: string; // when provided, clicking chip resets this InfoCard back into view
};

const Chip = ({ id, label, icon, onClick, className = '', cardId }: Props) => {
  const [isActive, setIsActive] = useState(() => isChipActive(id));

  useEffect(() => {
    const handleActivate = (e: CustomEvent<{ chipId: string }>) => {
      if (e.detail.chipId === id) setIsActive(true);
    };

    window.addEventListener(
      'jigsaw:promo:chip:activate',
      handleActivate as EventListener
    );
    return () =>
      window.removeEventListener(
        'jigsaw:promo:chip:activate',
        handleActivate as EventListener
      );
  }, [id]);

  if (!isActive) return null;

  const handleClick = () => {
    if (cardId) {
      resetInfoCard(cardId, id);
      setIsActive(false);
    } else {
      onClick?.();
    }
  };

  return (
    <div
      className={`${styles.chip} ${className}`}
      onClick={handleClick}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === 'Enter' && handleClick()}
    >
      <span className={styles.icon}>
        {icon ?? <img src={sparkleGif} alt="" />}
      </span>
      <span className={styles.label}>{label}</span>
    </div>
  );
};

export default Chip;
